// Pure function
// Never alter state or action directly
const answersDefaultState = {
    "core": {
        "11": {
            "111": "", 
            "112": "", 
            "113": "", 
            "114": "", 
            "115": "", 
            "116": ""
        },
        "12": {
            "121": "",
            "122": "", 
            "123": "", 
            "124": ""
        }
    },
    "finance": {
        "21": {
            "211": "", 
            "212": "", 
            "213": "", 
            "214": "", 
            "215": ""
        }
    },
    "operations": {
        "31": {
            "311": "", 
            "312": "", 
            "313": "", 
            "314": ""
        }, 
        "32": {
            "321": "", 
            "322": "", 
            "323": "", 
            "324": "", 
            "325": ""
        }, 
        "33": {
            "331": "", 
            "332": "", 
            "333": "", 
            "334": ""
        }, 
        "34": {
            "341": "", 
            "342": "", 
            "343": "", 
            "344": ""
        },
        "35": {
            "351": "", 
            "352": "", 
            "353": "", 
            "354": ""
        },
        "36": {
            "361": "", 
            "362": "", 
            "363": ""
        }
    },
    "staff": {
        "41": {
            "411": "", 
            "412": "", 
            "413": ""
        },
        "42": {
            "421": "", 
            "422": "", 
            "423": "", 
            "424": ""
        }
    },
    "patient": {
        "51": {
            "511": "", 
            "512": "", 
            "513": "", 
            "514": "", 
            "515": ""
        }, 
        "52": {
            "521": "", 
            "522": "", 
            "523": ""
        }
    }
}

export default (state=answersDefaultState, action) => {
    switch (action.type) {
        case 'SET_ANSWER':
            return {
                ...state,
                [action.secId]: {
                    ...state[action.secId],
                    [action.subSecId]: {
                        ...state[action.secId][action.subSecId],
                        ...action.answer
                    }
                }
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/answers.js